// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__Ci7_I","list":"BalanceDue_list__gXBoj","listRow":"BalanceDue_listRow__1O56D","total":"BalanceDue_total__28zA_"};